// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fadeHeight-enter-active[data-v-900380bc],\n.fadeHeight-leave-active[data-v-900380bc] {\n  transition: all 0.4s;\n  max-height: 230px;\n}\n.fadeHeight-enter-from[data-v-900380bc],\n.fadeHeight-leave-to[data-v-900380bc] {\n  opacity: 0;\n  max-height: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
